if (!customElements.get("highlighted-collections")) {
  class HighlightedCollections extends HTMLElement {
    constructor() {
      super();

      if (Shopify.designMode) {
        this._handleSectionLoad = (event) => {
          const loadedId = event.detail?.sectionId;
          const matches =
            loadedId != null
              ? String(loadedId) === String(this.dataset.sectionId)
              : event.target?.contains?.(this);

          if (!matches || !this.isConnected) {
            return;
          }

          this.init();
        };

        document.addEventListener(
          "shopify:section:load",
          this._handleSectionLoad,
        );
      }

      if (DeviceDetector.isDesktop()) {
        this.init();
      }
    }

    disconnectedCallback() {
      if (this._handleSectionLoad) {
        document.removeEventListener(
          "shopify:section:load",
          this._handleSectionLoad,
        );
      }
      this._hcAbort?.abort();
    }

    init() {
      this._hcAbort?.abort();
      this._hcAbort = new AbortController();
      this._bind(this._hcAbort.signal);
      this._applyIdle();
    }

    _applyIdle() {
      this.removeAttribute("data-hovering");

      this.querySelectorAll(".highlighted__collections-description").forEach(
        (el) => {
          el.classList.remove("highlighted__collections-description--active");
        },
      );

      this.querySelector('[data-description-id="default"]')?.classList.add(
        "highlighted__collections-description--active",
      );

      this.querySelectorAll(".highlighted__collections-image").forEach((el) => {
        el.classList.remove("highlighted-img--active");
      });

      const defaultImageIndex = this.dataset.defaultImageIndex;

      if (defaultImageIndex) {
        this.querySelector(
          `[data-hover="image-${defaultImageIndex}"]`,
        )?.classList.add("highlighted-img--active");
      }

      this.querySelectorAll(".highlighted__collections-item-box").forEach(
        (el) => {
          el.classList.remove("highlighted__collections-item-box--active");
        },
      );
    }

    _activate(index) {
      const id = String(index);
      const targetImageAttr = `image-${id}`;

      /* Dual-layer first row: idle/hover swap in CSS keys off this attribute */
      this.setAttribute("data-hovering", id);

      this.querySelectorAll(".highlighted__collections-description").forEach(
        (el) => {
          el.classList.toggle(
            "highlighted__collections-description--active",
            el.getAttribute("data-description-id") === id,
          );
        },
      );

      this.querySelectorAll(".highlighted__collections-image").forEach((el) => {
        el.classList.toggle(
          "highlighted-img--active",
          el.getAttribute("data-hover") === targetImageAttr,
        );
      });

      this.querySelectorAll(".highlighted__collections-item-box").forEach(
        (el) => {
          el.classList.toggle(
            "highlighted__collections-item-box--active",
            el.getAttribute("data-image") === id,
          );
        },
      );
    }

    _bind(signal) {
      const items = this.querySelectorAll(".highlighted__collections-item-box");
      const track = this.querySelector(".highlighted__collections-items-track");
      const sectionArea =
        this.querySelector(".highlighted__collections-area") ?? this;

      const handleActivateFromItem = (item) => {
        const index = item.getAttribute("data-image");

        if (index) {
          this._activate(index);
        }
      };

      sectionArea.addEventListener(
        "mouseleave",
        () => {
          this._applyIdle();
        },
        { signal },
      );

      sectionArea.addEventListener(
        "focusin",
        (event) => {
          const item = event.target.closest(
            ".highlighted__collections-item-box",
          );

          if (!item || !track?.contains(item)) {
            return;
          }

          handleActivateFromItem(item);
        },
        { signal, capture: true },
      );

      sectionArea.addEventListener(
        "focusout",
        (event) => {
          const next = event.relatedTarget;

          if (next && sectionArea.contains(next)) {
            return;
          }

          this._applyIdle();
        },
        { signal },
      );

      items.forEach((item) => {
        item.addEventListener(
          "mouseenter",
          () => {
            handleActivateFromItem(item);
          },
          { signal },
        );
      });
    }
  }

  customElements.define("highlighted-collections", HighlightedCollections);
}
